import moment from 'moment';

export const defaultSearchParams = () => {
    const beginDate = moment().subtract(1, 'months').toDate();
    const dateFrom = new Date();

    return {
        beginDate: beginDate.toISOString(),
        trucksDateFrom: dateFrom.toISOString(),
    };
};

export const buildVirtualPayRequest = (periodType) => ({
    timezoneOffset: new Date().getTimezoneOffset(),
    periodType: Number(periodType)
});

export const buildPayByCardRequest = (periodType) => ({
    timezoneOffset: new Date().getTimezoneOffset(),
    href: window.location.href,
    periodType: Number(periodType)
});

export const eventMetrics = {
    insufficientFunds: 1,
    openPopup: 2,
    closePopup: 3,
    confirmPay: 4,
    successPay: 5,
    transitionFromOwnCargoes: 6,
    transitionFromRating: 7,
    transitionFromUpdatePopupFreAccess: 8,
    openPassport: 9,
    openInviteToBoards: 10,
    openAddToList: 11,
    openTransportSearch: 12,
    scrollFirms: 13,
    openPopupByExternalLink: 14,
    tryOpenPopupByExternalLink: 15,
};

export const invitationSource = {
    activeTrackersSearch: 1
};
